<div style="width: 100%; height: 400px">
  <canvas [id]="idCanvas"></canvas>
</div>
